import { CommandType } from "../../../../common/services/cqs/CommandType";
import { SkogsvardTradslagBaseCommand } from "./SkogsvardTradslagBaseCommand";

export class CreateSkogsvardTradslagCommand extends SkogsvardTradslagBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateSkogsvardTradslagCommand";

    constructor(atgardGuid: string, guid: string) {
        super(atgardGuid, guid, CreateSkogsvardTradslagCommand.$type, CommandType.Insert);
    }
}
